/* Global imports. */
import React from "react"
import { Link } from "gatsby"

interface Props {
  url: string;
  text?: string;
  cssClass?: string;
}

const LinkWrapper = ({ url, text, cssClass }: Props)  => {
  return url && url.startsWith("http") ? ( 
    <a className={cssClass} href={url} target="_blank">{text}</a>
  ) : (
    <Link className={cssClass} to={url}>{text}</Link>
  )
};

export default LinkWrapper;
